import createIcon from '../../createIcon';

/**
 * @component @name ViewList
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMyAxNEg3VjEwSDNWMTRaTTMgMTlIN1YxNUgzVjE5Wk0zIDlIN1Y1SDNWOVpNOCAxNEgyMVYxMEg4VjE0Wk04IDE5SDIxVjE1SDhWMTlaTTggNVY5SDIxVjVIOFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ViewList = createIcon('ViewList', [
  [
    'path',
    {
      d: 'M3 14H7V10H3V14ZM3 19H7V15H3V19ZM3 9H7V5H3V9ZM8 14H21V10H8V14ZM8 19H21V15H8V19ZM8 5V9H21V5H8Z',
      key: 'xbnj0c',
    },
  ],
]);

export default ViewList;
